module.exports = __webpack_public_path__ + "static/media/banner_header_claro_woman.600fb9b6.webp";